import React from 'react';
import { useLocation } from 'react-router-dom';
import ExcelLikeView from './ExcelLikeView';
import CampaignsSnapshotExcel from './CampaignsSnapshotExcel';

/**
 * ExcelViewRouter Component
 * 
 * Routes between regular Excel view and snapshot Excel view based on query parameters
 * - If snapshotMonth exists: use CampaignsSnapshotExcel (specialized for snapshots)  
 * - Otherwise: use ExcelLikeView (regular live data)
 */
const ExcelViewRouter = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const snapshotMonth = params.get('snapshotMonth');

  // If snapshot month is present, use specialized snapshot Excel component
  if (snapshotMonth) {
    return <CampaignsSnapshotExcel />;
  }

  // Otherwise use regular Excel view for live data
  return <ExcelLikeView />;
};

export default ExcelViewRouter; 